import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-temrs-and-conditions',
  templateUrl: './temrs-and-conditions.component.html',
  styleUrl: './temrs-and-conditions.component.scss',
})
export class TemrsAndConditionsComponent {
  constructor(public translate: TranslateService) {}

  get language() {
    return this.translate.currentLang;
  }
}
